<template>
  <div>
    <md-dialog
      :md-active.sync="show"
      :md-close-on-esc="false"
      @md-clicked-outside="closeDialog"
      @keyup.esc="closeDialog"
      @keyup.enter="setLicense"
    >
      <md-dialog-title>Set License</md-dialog-title>
      <div class="md-dialog-content md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
        <md-field>
          <label> Settings Hash </label>
          <md-input v-model="settingsHash" disabled></md-input>
          <md-button class="md-icon-button md-list-action" @click="copySettingsHash">
            <md-icon>file_copy</md-icon>
          </md-button>
        </md-field>

        <md-field :class="licenseErrorClass">
          <label> License </label>
          <md-textarea v-model="license"></md-textarea>
          <span class="md-error">{{ licenseError }}</span>
        </md-field>

        <div class="md-layout-item md-size-100 text-right">
          <md-button @click="closeDialog">Close</md-button>
          <md-button class="md-primary" @click="setLicense">Set</md-button>
        </div>
      </div>
    </md-dialog>
    <waiting-for-server
      :show="showWaitingForServerDialog"
      @close="showWaitingForServerDialog = false"
    ></waiting-for-server>
  </div>
</template>

<script>
import { computed, ref } from "@vue/composition-api";
import apiManager from "../api-manager";
import NotificationStore from "./NotificationPlugin/NotificationStore";
import WaitingForServer from "./WaitingForServer.vue";

export default {
  components: { WaitingForServer },
  name: "SetLicense",
  props: {
    show: {
      type: Boolean,
    },
    settingsHash: {
      default: "",
      type: String,
    },
  },
  setup(props, { emit }) {
    const licenseError = ref("");
    const licenseErrorClass = computed(() => {
      return {
        "md-invalid": licenseError.value,
      };
    });
    const resetErrors = () => {
      licenseError.value = "";
    };

    const copySettingsHash = async () => {
      try {
        await navigator.clipboard.writeText(props.settingsHash);
        NotificationStore.notify({
          message: "Successfully copied!",
          icon: "add_alert",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "success",
        });
      } catch {
        /* */
      }
    };
    const license = ref("");
    const setLicense = async () => {
      if (license.value.trim() === "") {
        licenseError.value = "License can not be empty";
        return;
      }
      const response = await apiManager.setLicense({
        params: { license: license.value },
      });
      if (response.status === 200) {
        NotificationStore.notify({
          message: response.parsedData.message,
          icon: "add_alert",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "success",
        });
        showWaitingForServerDialog.value = true;
        closeDialog();
      } else {
        if (response.parsedError === "license") licenseError.value = "License is not valid!";
        else licenseError.value = response.parsedError;
      }
    };

    const closeDialog = () => {
      resetErrors();
      emit("close");
    };

    const showWaitingForServerDialog = ref(false);
    return {
      licenseError,
      licenseErrorClass,

      copySettingsHash,
      license,
      setLicense,

      closeDialog,
      showWaitingForServerDialog,
    };
  },
};
</script>
